if (!customElements.get('rating-stars')) {
	class ratingStars extends HTMLElement {
		connectedCallback() {
			this.rating = parseFloat(this.getAttribute('rating')) || 5;
			this.innerHTML = this.generateStarIcons();
		}
		generateStarIcons() {
			const { fullStar, halfStar, emptyStar } = window.themeVariables.icons;
			let filledStars = '';
			let emptyStars = '';
			let fullStars = Math.floor(this.rating);
			let partialStar = this.rating - fullStars;

			filledStars = fullStar.repeat(fullStars);

			if (partialStar > 0) {
				if (partialStar <= 0.7) {
					filledStars += halfStar;
				} else {
					filledStars += fullStar;
				}
				fullStars += 1;
			}

			emptyStars = emptyStar.repeat(5 - fullStars);

			return filledStars + emptyStars;
		}
	}

	customElements.define('rating-stars', ratingStars);
}
